/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';
import { Duration, DateTime } from 'luxon';

const SummaryReport = ({ listItem, title }) => {
  const {
    deleters: { deleteUser },
  } = useContext(MainContext);
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [totals, setTotals] = useState({
    inviter_all_leads: 0,
    captures_on_time: 0,
    attendances_on_time: 0,
    had_contact: 0,
    quoted: 0,
    backup_car: 0,
    pague_menos: 0,
    sold: 0,
    conversion: 0,
  });
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });

  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Corretor</TableCell>
              <TableCell>Capturados nas Datas Solicitadas</TableCell>
              <TableCell>Capturados em até 3h</TableCell>
              <TableCell>Finalizados em até 24h</TableCell>
              <TableCell>Houve Contato com o Cliente</TableCell>
              <TableCell>Houve envio de Proposta</TableCell>
              <TableCell>Indicou BackupCar</TableCell>
              <TableCell>Indicou Seguro Franquia</TableCell>
              <TableCell>Seguros Vendidos</TableCell>
              <TableCell>Aproveitamento / Conversão</TableCell>
              <TableCell>Tempo em Negociação</TableCell>
              <TableCell>Ranking</TableCell>
              {/* <TableCell align="right">Ações</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {listItem?.map((item) => (
              <TableRow key={item?.broker_id}>
                <TableCell>{item?.broker_name || '-'}</TableCell>
                <TableCell>{item?.broker_all_leads}</TableCell>
                <TableCell>{item?.captures_on_time || '-'}</TableCell>
                <TableCell>{item?.attendances_on_time || '-'}</TableCell>
                <TableCell>{item?.had_contact || '-'}</TableCell>
                <TableCell>{item?.quoted || '-'}</TableCell>
                <TableCell>{item?.backup_car || '-'}</TableCell>
                <TableCell>{item?.pague_menos || '-'}</TableCell>
                <TableCell>{item?.sold || '-'}</TableCell>
                <TableCell>{item?.conversion} %</TableCell>
                <TableCell>{item?.negotiation_time}</TableCell>
                <TableCell>* {item?.ranking} * </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Total</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.broker_all_leads);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.captures_on_time);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.attendances_on_time);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.had_contact);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.quoted);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.backup_car);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.pague_menos);
                }, 0)}
              </TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>
                {listItem?.reduce(function (sum, current) {
                  return parseInt(sum) + parseInt(current?.sold);
                }, 0)}
              </TableCell>

              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

SummaryReport.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
};

SummaryReport.defaultProps = {
  listItem: null,
};

export default SummaryReport;
